<template>
  <v-container full-width style="width: 100%">
    <v-row>
      <v-col grow>
        <v-autocomplete
          background-color="transparent"
          color="primary"
          solo
          clearable
          append-icon="search"
          v-model="select"
          :loading="loading"
          :items="items"
          :search-input.sync="search"
          cache-items
          class="mx-4"
          text
          hide-no-data
          hide-details
          label="What state are you from?"
        >
          <template v-slot:selection="data">{{ data.item.name }}</template>

          <template v-slot:item="data">
            <template v-if="data.item.constructor.name !== 'Object'">
              <v-list-item-content>
                <span>{{ data.item }}</span>
              </v-list-item-content>
            </template>
            <template v-else>
              <v-list-item-content>
                <v-list-item-title
                  ><span v-html="data.item.name"></span
                ></v-list-item-title>
                <v-list-item-subtitle
                  ><span v-html="data.item.surname"></span
                ></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      search: null,
      select: null
    };
  },
  props: {
    items: {
      default: () => [],
      // some pages have search filled but they are not children of baseList
      required: false
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    }
  },
  methods: {
    querySelections(v) {
      // this.loading = true;
      this.$emit("search", v);
      this.loading = true;

      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  }

  // data() {
  //   return {
  //     searchQuery: ""
  //   };
  // },
  // watch: {
  //   config: {
  //     handler: function(val, oldVal) {
  //       this.searchQuery = val ? val.initValue : "";
  //     },
  //     deep: true
  //   }
  // },
  // computed: {
  //   placeholder() {
  //     const TRANSLATE_ID = this.config
  //       ? this.config.placeholder
  //       : "searchDefault";
  //     return this.$t(TRANSLATE_ID);
  //   }
  // },
  // methods: {
  //   search() {
  //     this.$emit("search", this.searchQuery);
  //   },
  //   searchChanged() {
  //     if (!this.searchQuery) {
  //       // this.$emit("search", this.searchQuery);
  //     }
  //   },
  //   searchInput() {
  //     // this.$emit("search", this.searchQuery);
  //   }
  // },
  // created() {
  //   this.searchQuery = this.config ? this.config.initValue : "";
  // }
};
</script>

<style scoped>
.container {
  padding: 0 !important;
}

.v-input__slot {
  height: 40px;
  min-height: unset;
}
</style>
